<template>
  <div class="amount-selector mt-3 mb-3" v-if="prices && list.length > 1">
    <div class="row">
      <div class="col-sm-5 py-2 text-center text-sm-left amount-selector__title">
        {{ $t("upsells.choose_amount") }}
      </div>
      <div class="col-sm-7">
        <select-field :standart="false" :bars="true" v-model="quantity" :list="list" />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-4 col-sm-5 amount-selector__title">
        {{ $t("upsells.total_price") }}
      </div>
      <div class="col-8 col-sm-7 text-right">
        <div class="amount-selector__discount mx-2">
          <img :src="$root.cdn_url + '/assets/images/upsells/discount-icon.svg'" class="mr-1" alt="" />
          {{ $t("upsells.save") }} 50%
        </div>
        <div class="amount-selector__price">
          {{ totalPrice }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["list", "prices"],
  data() {
    return {
      quantity: 1
    };
  },
  computed: {
    totalPrice() {
      return this.prices[this.quantity].price_text;
    }
  },
  watch: {
    quantity: {
      handler(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style></style>
